export const classes = {
  wrapper: 'pt-3 place-between',
  button: 'py-1 text-base font-normal',
  deleteText: 'text-red-2',
  editText: 'text-brand-accent dark:text-brand-accent-dark',
};
